import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "d-flex align-center mb-4" };
const _hoisted_2 = { class: "d-flex align-center mb-4" };
const _hoisted_3 = { class: "group-card-label" };
const _hoisted_4 = { class: "d-flex align-center mb-4" };
const _hoisted_5 = { class: "d-flex align-center mb-4" };
const _hoisted_6 = { class: "d-flex align-center mb-4" };
const _hoisted_7 = { class: "d-flex align-center mb-4" };
const _hoisted_8 = { class: "d-flex align-center mb-4" };
const _hoisted_9 = { class: "d-flex align-center mb-4" };
const _hoisted_10 = { class: "d-flex align-center mb-4" };
const _hoisted_11 = { class: "swipe-container" };
const _hoisted_12 = { class: "document-content" };
const _hoisted_13 = { class: "d-flex align-center" };
const _hoisted_14 = { class: "flex-grow-1" };
const _hoisted_15 = { class: "docCol" };
const _hoisted_16 = { class: "doc-date" };
const _hoisted_17 = { class: "d-flex align-center mb-4" };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = { key: 1 };
const _hoisted_20 = { class: "d-flex align-center mb-4" };
const _hoisted_21 = { class: "savings-card-container" };
const _hoisted_22 = { class: "d-flex align-center mb-4" };
const _hoisted_23 = { class: "mb-4" };
const _hoisted_24 = { class: "d-flex align-center mb-4" };
const _hoisted_25 = { class: "mb-4" };
const _hoisted_26 = { class: "pagination-controls mb-4" };
const _hoisted_27 = { class: "pagination-examples" };
const _hoisted_28 = { class: "example-section mb-4" };
const _hoisted_29 = { class: "example-section mb-4" };
const _hoisted_30 = { class: "example-section mb-4" };
const _hoisted_31 = { class: "d-flex align-center mb-4" };
const _hoisted_32 = { class: "d-flex align-center mb-4" };
const _hoisted_33 = { class: "d-flex align-center mb-4" };
const _hoisted_34 = { class: "d-flex align-center mb-4" };
const _hoisted_35 = { class: "d-flex align-center mb-4" };
const _hoisted_36 = { class: "d-flex align-center mb-4" };
const _hoisted_37 = { class: "d-flex align-center mb-4" };
const _hoisted_38 = { class: "d-flex align-center mb-4" };
const _hoisted_39 = { class: "d-flex align-center mb-4" };
const _hoisted_40 = { class: "d-flex align-center mb-4" };
const _hoisted_41 = { class: "voucher-basket-examples" };
const _hoisted_42 = { class: "example-section mb-4" };
const _hoisted_43 = { class: "example-section mb-4" };
const _hoisted_44 = { class: "example-section mb-4" };
const _hoisted_45 = { class: "example-section mb-4" };
const _hoisted_46 = { class: "d-flex align-center mb-4" };
const _hoisted_47 = { class: "card-account-group-container" };
const _hoisted_48 = { class: "d-flex align-center mb-4" };
const _hoisted_49 = { class: "account-list-items-container" };
const _hoisted_50 = { class: "d-flex align-center mb-4" };
const _hoisted_51 = { class: "account-type-lozenge-container" };
const _hoisted_52 = { class: "d-flex align-center mb-4" };
const _hoisted_53 = { class: "d-flex align-center mb-4" };
const _hoisted_54 = { class: "d-flex align-center mb-4" };
const _hoisted_55 = { class: "d-flex align-center mb-4" };
const _hoisted_56 = { class: "toggle-examples" };
const _hoisted_57 = {
    class: "d-flex align-center mb-4",
    style: { "gap": "16px" }
};
const _hoisted_58 = {
    class: "d-flex align-center mb-4",
    style: { "gap": "16px" }
};
const _hoisted_59 = {
    class: "d-flex align-center mb-4",
    style: { "gap": "16px" }
};
const _hoisted_60 = {
    class: "d-flex align-center mb-4",
    style: { "gap": "16px" }
};
import { ref, onMounted, useTemplateRef } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useContent } from '@/composables/useContent';
import AddressLookup from './elements/AddressLookup.vue';
import AddressDrawer from './elements/AddressDrawer.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import BarArrowButton from './elements/BarArrowButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import TagInput from './elements/TagInput.vue';
import SwipeCarousel from './elements/SwipeCarousel.vue';
import SpendingSummaryCard from './elements/SpendingSummaryCard.vue';
import AccountsWidget from './elements/AccountsWidget.vue';
import SwipeActionsContainer from './elements/SwipeActionsContainer.vue';
import MGDialog from './elements/MGDialog.vue';
import SavingsCard from './elements/SavingsCard.vue';
import MonthSelector from './elements/MonthSelector.vue';
import PaginationDots from './elements/PaginationDots.vue';
import SmoothScrollContainer from './elements/SmoothScrollContainer.vue';
import CategoryButton from './elements/CategoryButton.vue';
import MGNavPanel from './elements/MGNavPanel.vue';
import BuyWithConfidenceShoutPanel from './elements/BuyWithConfidenceShoutPanel.vue';
import ReLinkAccountsForVouchersShoutPanel from './elements/ReLinkAccountsForVouchersShoutPanel.vue';
import VoucherRecommendedForYou from './elements/VoucherRecommendedForYou.vue';
import VoucherSavingSuggestions from './elements/VoucherSavingSuggestions.vue';
import VoucherMerchantCard from './elements/VoucherMerchantCard.vue';
import SectionHeader from './elements/SectionHeader.vue';
import VoucherBasket from './elements/VoucherBasket.vue';
import CardAccountGroup from './elements/CardAccountGroup.vue';
import AccountListItem from './elements/AccountListItem.vue';
import AccountTypeLozenge from './elements/AccountTypeLozenge.vue';
// import VoucherEditForm from './elements/VoucherEditForm.vue'
import MGToggle from './elements/MGToggle.vue';
import WalkthroughDrawerPanel from './elements/WalkthroughDrawerPanel.vue';
import SavedToSpendBalance from './elements/SavedToSpendBalance.vue';
import DiscountTransactionsSection from './elements/DiscountTransactionsSection.vue';
import ProgressDial from './elements/ProgressDial.vue';
import ProgressDialV2 from './elements/ProgressDialV2.vue';
import TransactionGroupCard from './elements/TransactionGroupCard.vue';
import { useAppState } from '@/composables/useAppState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TestPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const { getWalkthrough } = useContent();
        const walkthroughDrawer = useTemplateRef('walkthroughDrawer');
        const sections = ref({
            carousel: false,
            groupCards: true,
            loader: false,
            tags: false,
            numeric: false,
            postcode: false,
            addressDrawer: false,
            buttons: false,
            swipeActions: false,
            mgDialog: false,
            savingsCard: false,
            monthSelector: false,
            paginationDots: false,
            smoothScroll: false,
            navPanel: false,
            buyWithConfidence: false,
            VoucherRecommendedForYou: false,
            VoucherRecommendedForYouSmall: false,
            savingOpportunityCard: false,
            merchantCard: false,
            sectionHeader: true,
            voucherBasket: false,
            voucherEditForm: false,
            cardAccountGroup: false,
            accountListItem: false,
            accountTypeLozenge: false,
            savedToSpendBalance: false,
            recentDiscountTransactions: false,
            progressDial: true,
            progressDialV2: true,
            mgToggle: false,
            reLinkAccountsForVouchers: false,
        });
        const toggleLargeOn = ref(true);
        const toggleLargeOff = ref(false);
        const toggleSmallOn = ref(true);
        const toggleSmallOff = ref(false);
        const loaderCustomer = ref(true);
        const selectableTags = ref(['vue', 'vueJs', 'javascript', 'typescript', 'wibble', 'foo', 'bar', 'baz', 'qux', 'quux', 'corge', 'grault', 'garply', 'waldo', 'fred', 'plugh', 'xyzzy', 'thud']);
        const modelValue = ref(['vue', 'vueJs']);
        const address = ref(null);
        const showAddressDrawer = ref(false);
        const amount = ref(0);
        const sheetWalkthroughData = ref(null);
        const dummySpendingSummary = {
            rangeLabel: '',
            net: 1240,
            totalIn: 2800,
            totalOut: 1560,
            breakdown: [],
        };
        const storyWalkthroughData = ref(null);
        const mockAccounts = ref([
            {
                "id": "08dd7d15-cd62-45be-85d4-42866ca80ca7",
                "bank": {
                    "id": "08dce6ad-fe1a-45a8-8cdd-394366150346",
                    "name": "FIRST-DIRECT",
                    "prettyName": null,
                    "logoUri": "https://truelayer-client-logos.s3-eu-west-1.amazonaws.com/banks/banks-icons/ob-first-direct-icon.svg",
                    "logoPath": null,
                    "hexColour1": null,
                    "hexColour2": null,
                    "invertCreditCardBalance": true
                },
                "accountType": {
                    "id": "08da73f8-64b3-4b3d-842e-45f574933979",
                    "name": "TRANSACTION",
                    "prettyName": "Current",
                    "prettyLongName": "Current account",
                    "dashIconPath": "currentAccountIcon.svg",
                    "smallIconPath": "currentAccountIconMoney.svg"
                },
                "directDebits": null,
                "usageType": null,
                "groupedTransactions": null,
                "customerID": "08dd6557-20ff-4b94-87b4-dd3c9e04000a",
                "source": 0,
                "jointStatus": 0,
                "accountTypeDisplayName": "TRANSACTION",
                "card": false,
                "displayName": null,
                "bankDisplayName": "FIRST-DIRECT",
                "accountNumber": "34133501",
                "sortCode": "40-47-83",
                "providerAccountID": "64d1c1f3b75939192064e57ffcc7eaed",
                "currency": "GBP",
                "createDateTime": "2025-04-16T18:37:54.991505",
                "balance": 5455.63,
                "available": 5781.55,
                "overdraftFacility": 500,
                "lastRefreshed": "2025-05-08T06:00:12.580599",
                "consentExpired": false,
                "consentRefreshFailed": false,
                "relevance": 1
            }
        ]);
        const mockSwipeItems = ref([
            {
                id: 1,
                title: 'Document 1',
                subtitle: 'Created 2 hours ago',
                icon: 'mdi-file-document-outline'
            },
            {
                id: 2,
                title: 'Document 2',
                subtitle: 'Created yesterday',
                icon: 'mdi-file-pdf-box'
            },
            {
                id: 3,
                title: 'Document 3',
                subtitle: 'Created 3 days ago',
                icon: 'mdi-file-word'
            }
        ]);
        const showSimpleDialog = ref(false);
        const showFormDialog = ref(false);
        const showMultiPageDialog = ref(false);
        const currentPage = ref(1);
        const page1Data = ref('');
        const page2Data = ref('');
        const formName = ref('');
        const formEmail = ref('');
        const mockSavingsItems = ref([
            {
                value: 2240,
                label: 'Saved to spend'
            },
            {
                value: 1850,
                label: 'Saved this month'
            },
            {
                value: 12500,
                label: 'All time savings'
            }
        ]);
        const selectedMonth = ref('July 2025');
        const mockMonthSlots = ref([
            { key: 'May 2024', label: 'May' },
            { key: 'June 2024', label: 'Jun' },
            { key: 'July 2024', label: 'Jul' },
            { key: 'August 2024', label: 'Aug' },
            { key: 'September 2024', label: 'Sep' },
            { key: 'October 2024', label: 'Oct' },
            { key: 'November 2024', label: 'Nov' },
            { key: 'December 2024', label: 'Dec' },
            { key: 'January 2025', label: 'Jan' },
            { key: 'February 2025', label: 'Feb' },
            { key: 'March 2025', label: 'Mar' },
            { key: 'April 2025', label: 'Apr' },
            { key: 'May 2025', label: 'May' },
            { key: 'June 2025', label: 'Jun' },
            { key: 'July 2025', label: 'Jul' },
            { key: 'August 2025', label: 'Aug' },
            { key: 'September 2025', label: 'Sep' },
            { key: 'October 2025', label: 'Oct' },
            { key: 'November 2025', label: 'Nov' },
            { key: 'December 2025', label: 'Dec' },
            { key: 'January 2026', label: 'Jan' },
            { key: 'February 2026', label: 'Feb' }
        ]);
        const paginationCurrentIndex = ref(0);
        const paginationTotalItems = ref(7);
        const mockCategories = ref([
            { title: 'Bakery & Coffee', image: require('../assets/categories/bakery-coffee.png') },
            { title: 'Entertainment', image: require('../assets/categories/entertainment.png') },
            { title: 'Family', image: require('../assets/categories/family.png') },
            { title: 'Fashion', image: require('../assets/categories/fashion.png') },
            { title: 'Gifts', image: require('../assets/categories/gifts.png') },
            { title: 'Home & Garden', image: require('../assets/categories/home-garden.png') },
            { title: 'Hotels', image: require('../assets/categories/hotels.png') },
            { title: 'Leisure', image: require('../assets/categories/leisure.png') }
        ]);
        const mockSavingOpportunities = ref([
            {
                totalSpendAmount: '£4,400',
                logoUrl: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/3e242bda-SainsburysPorthole.png',
                logoAltText: 'Sainsbury\'s',
                savingAmount: '£124.25',
                savingPercentage: '5.5%',
                logoBackgroundColor: '#F07F00',
                totalSpendLabel: 'Total Spend'
            },
            {
                logoUrl: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/257ad329-Porthole.png',
                logoAltText: 'Airbnb',
                savingAmount: '£100.00',
                savingPercentage: '5.5%',
                logoBackgroundColor: '#FF5A5F',
                totalSpendLabel: 'Biggest Single Saving'
            },
            {
                totalSpendAmount: '£3,200',
                logoUrl: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/5a6b0438-Sainsbury%27s.png',
                logoAltText: 'Sainsbury\'s',
                savingAmount: '£88.50',
                savingPercentage: '4.2%',
                logoBackgroundColor: '#F07F00'
            }
        ]);
        const mockMerchantCards = ref([
            {
                logoUrl: 'https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/airbnb.jpg',
                merchantName: 'Airbnb',
                savingPercentage: '5.5%',
                isFavorited: true
            },
            {
                logoUrl: 'https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/airbnb.jpg',
                merchantName: 'Adidas',
                savingPercentage: '12.5%',
                isFavorited: false
            },
            {
                logoUrl: 'https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/airbnb.jpg',
                merchantName: 'Sainsbury\'s',
                savingPercentage: '4.2%',
                isFavorited: true
            },
        ]);
        const mockCardAccountGroups = ref([
            {
                cardTitle: 'Investments',
                amount: 3722.00,
                illustrationUrl: 'https://www.figma.com/api/mcp/asset/fe1b4776-7d41-4ea1-a1cc-55d5581780d3',
                accountAvatars: [
                    {
                        url: 'https://www.figma.com/api/mcp/asset/1142ec1a-a7c8-41be-8c81-48babbbbdbaf',
                        alt: 'Avatar 1'
                    },
                    {
                        url: 'https://www.figma.com/api/mcp/asset/af21fedd-28d5-482a-857b-f64fd5557e64',
                        alt: 'Avatar 2'
                    },
                    {
                        url: 'https://www.figma.com/api/mcp/asset/1142ec1a-a7c8-41be-8c81-48babbbbdbaf',
                        alt: 'Avatar 3'
                    }
                ]
            },
            {
                cardTitle: 'Savings',
                amount: 1500.50,
                illustrationUrl: 'https://www.figma.com/api/mcp/asset/fe1b4776-7d41-4ea1-a1cc-55d5581780d3',
                accountAvatars: [
                    {
                        url: 'https://www.figma.com/api/mcp/asset/af21fedd-28d5-482a-857b-f64fd5557e64',
                        alt: 'Avatar 1'
                    },
                    {
                        url: 'https://www.figma.com/api/mcp/asset/1142ec1a-a7c8-41be-8c81-48babbbbdbaf',
                        alt: 'Avatar 2'
                    }
                ]
            }
        ]);
        const mockAccountListItems = ref([
            {
                bankName: 'Monzo',
                accountType: 'Current Account',
                accountNumber: '*****345',
                balance: 522.00,
                avatarUrl: require('@/assets/thumbnails/badge.png'),
                badgeUrl: require('@/assets/thumbnails/badge.png')
            },
            {
                bankName: 'HSBC',
                accountType: 'Savings Account',
                accountNumber: '*****678',
                balance: 1250.75,
                avatarUrl: require('@/assets/thumbnails/badge.png'),
                badgeUrl: ''
            },
            {
                bankName: 'Barclays',
                accountType: 'Current Account',
                accountNumber: '*****901',
                balance: 3456.50,
                avatarUrl: require('@/assets/thumbnails/badge.png'),
                badgeUrl: require('@/assets/thumbnails/badge.png')
            }
        ]);
        const mockAccountTypeLozenges = ref([
            {
                accountType: 'Current Account',
                accountCount: 2,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: false
            },
            {
                accountType: 'Credit Card',
                accountCount: 2,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: false
            },
            {
                accountType: 'Savings',
                accountCount: 8,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: false
            },
            {
                accountType: 'Investments',
                accountCount: null,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: true
            },
            {
                accountType: 'Pension',
                accountCount: null,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: true
            },
            {
                accountType: 'Mortgage',
                accountCount: 2,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: false
            },
            {
                accountType: 'Loans',
                accountCount: null,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: true
            },
            {
                accountType: 'Insurance Policy',
                accountCount: null,
                iconUrl: require('@/assets/transactions/debts.svg'),
                isAddButton: true
            }
        ]);
        const mockTransactionDays = ref([
            {
                date: '2026-01-13T00:00:00',
                purchases: [
                    {
                        merchantName: 'Waitrose & Partners',
                        icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/waitrose.jpg',
                        faceValue: 123,
                        savedToSpendEarningsAmount: 3.08,
                        savingPercentage: 2.5,
                        usedSavedToSpend: null
                    },
                    {
                        merchantName: 'Amazon',
                        icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/amazon.jpg',
                        faceValue: 12,
                        savedToSpendEarningsAmount: 0.24,
                        savingPercentage: 2,
                        usedSavedToSpend: null
                    }
                ]
            },
            {
                date: '2026-01-12T00:00:00',
                purchases: [
                    {
                        merchantName: 'Browns',
                        icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/browns.jpg',
                        faceValue: 200,
                        savedToSpendEarningsAmount: 23,
                        savingPercentage: 11.5,
                        usedSavedToSpend: 200
                    },
                    {
                        merchantName: 'ODEON',
                        icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/odeon.jpg',
                        faceValue: 12,
                        savedToSpendEarningsAmount: 0.42,
                        savingPercentage: 3.5,
                        usedSavedToSpend: null
                    }
                ]
            },
            {
                date: '2026-01-07T00:00:00',
                purchases: [
                    {
                        merchantName: 'Caffè Nero',
                        icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/caffe-nero.jpg',
                        faceValue: 100,
                        savedToSpendEarningsAmount: 9.5,
                        savingPercentage: 9.5,
                        usedSavedToSpend: null
                    }
                ]
            },
            {
                date: '2026-01-05T00:00:00',
                purchases: [
                    {
                        merchantName: 'Starbucks',
                        icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/starbucks.jpg',
                        faceValue: 50,
                        savedToSpendEarningsAmount: 4.75,
                        savingPercentage: 9.5,
                        usedSavedToSpend: null
                    }
                ]
            }
        ]);
        const state = useAppState();
        // TransactionBulkPage card amount scenarios: credits get a "cr" suffix, groups show Latest + Total.
        const mockGroupCardAccount = { ...mockAccounts.value[0], displayName: '1st Account', accountNumber: '12345675' };
        const groupCardScenarios = [
            { label: 'Single spend', amount: -4.99, latestAmount: -4.99, count: 1 },
            { label: 'Single credit', amount: 150, latestAmount: 150, count: 1 },
            { label: 'Single big credit', amount: 123456.78, latestAmount: 123456.78, count: 1 },
            { label: 'Group of credits', amount: 1150, latestAmount: 150, count: 2 },
            { label: 'Group of big credits', amount: 111111.1, latestAmount: 12345.67, count: 2 },
            { label: 'Group of big spends', amount: -9889.04, latestAmount: -9876.54, count: 3 },
            { label: 'Group, spend latest but net credit (refund)', amount: 130, latestAmount: -20, count: 3 },
            { label: 'Zero', amount: 0, latestAmount: 0, count: 1 },
        ];
        function toggleSection(key) {
            sections.value[key] = !sections.value[key];
        }
        async function onLoad() {
            console.log(window.location.origin + '/#/');
        }
        function handleSwipeItemClick({ item }) {
            console.log('Item clicked:', item);
        }
        function handleSwipeAction({ item, action }) {
            console.log('Action clicked:', action.type, 'on item:', item);
        }
        function saveForm() {
            console.log('Form saved:', formName.value, formEmail.value);
            showFormDialog.value = false;
        }
        function closeMultiPageDialog() {
            showMultiPageDialog.value = false;
            currentPage.value = 1;
        }
        function completeMultiPage() {
            console.log('Multi-page dialog completed');
            showMultiPageDialog.value = false;
        }
        function prevItem() {
            if (paginationCurrentIndex.value > 0) {
                paginationCurrentIndex.value--;
            }
        }
        function nextItem() {
            if (paginationCurrentIndex.value < paginationTotalItems.value - 1) {
                paginationCurrentIndex.value++;
            }
        }
        function onNavPanelClick() {
            alert('Nav Panel clicked!');
        }
        function onSectionHeaderAction() {
            alert('Section header action clicked!');
        }
        function handleVoucherBasketClick(type) {
            console.log(`VoucherBasket clicked: ${type}`);
            alert(`Clicked ${type} VoucherBasket! Ready to proceed to checkout.`);
        }
        function handleEditFormClose() {
            console.log('Edit form closed');
        }
        function handleEditFormUpdate(data) {
            console.log('Edit form updated:', data);
        }
        function handleAccountListItemClick(account) {
            console.log('Account list item clicked:', account);
        }
        function handleAccountTypeLozengeClick(data) {
            console.log('Account type lozenge clicked:', data);
        }
        function handleShopClick() {
            console.log('Shop button clicked');
        }
        function handleViewMoreTransactions() {
            console.log('View more transactions clicked');
        }
        function openWalkthroughDrawer() {
            walkthroughDrawer.value?.openDrawer();
        }
        function loadSheetWalkthrough() {
            getWalkthrough('money-account-types', (result) => {
                console.log('Sheet walkthrough data loaded:', result);
                sheetWalkthroughData.value = result;
            });
        }
        function loadStoryWalkthrough() {
            getWalkthrough('money-how-it-works', (result) => {
                console.log('Story walkthrough data loaded:', result);
                storyWalkthroughData.value = result;
            });
        }
        function handleWalkthroughOpened() {
            console.log('Walkthrough drawer opened');
        }
        function handleWalkthroughClosed() {
            console.log('Walkthrough drawer closed');
        }
        function openStoryPage() {
            router.push('/story/money-how-it-works');
        }
        onMounted(() => {
            loadSheetWalkthrough();
            loadStoryWalkthrough();
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_carousel_item = _resolveComponent("v-carousel-item");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    share: true,
                    title: "Test Page"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[64] || (_cache[64] = _createElementVNode("h3", { class: "mb-0" }, "Carousel", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleSection('carousel'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.carousel ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SwipeCarousel, {
                        showArrows: false,
                        showButtons: true
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_carousel_item, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", {
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).push('/SpendingAnalysis')))
                                                    }, [
                                                        _createVNode(SpendingSummaryCard, {
                                                            compact: true,
                                                            compactTitle: "Spending Analysis",
                                                            data: dummySpendingSummary
                                                        })
                                                    ])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_carousel_item, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(AccountsWidget, {
                                                        accounts: mockAccounts.value,
                                                        formatter: { format: v => '£' + v.toLocaleString() }
                                                    }, null, 8, ["accounts", "formatter"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, sections.value.carousel]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_2, [
                    _cache[65] || (_cache[65] = _createElementVNode("h3", { class: "mb-0" }, "Transaction group cards", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[2] || (_cache[2] = ($event) => (toggleSection('groupCards'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.groupCards ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(groupCardScenarios, (s) => {
                        return _createElementVNode("div", {
                            key: s.label,
                            class: "group-card-scenario"
                        }, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(s.label), 1),
                            _createVNode(TransactionGroupCard, {
                                account: mockGroupCardAccount,
                                merchant: "R ORMOND",
                                amount: s.amount,
                                latestAmount: s.latestAmount,
                                date: "Thursday, 1 Oct 26",
                                rawDate: "2026-10-01T10:00:00Z",
                                count: s.count,
                                formatter: _unref(state).formatter,
                                selected: true,
                                transactionId: "test",
                                tx: { merchantName: 'R ORMOND', amount: s.latestAmount }
                            }, null, 8, ["amount", "latestAmount", "count", "formatter", "tx"])
                        ]);
                    }), 64))
                ], 512), [
                    [_vShow, sections.value.groupCards]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _cache[116] || (_cache[116] = _createElementVNode("div", { class: "d-flex align-center mb-4" }, [
                    _createElementVNode("h3", { class: "mb-0" }, "Walkthrough")
                ], -1)),
                (sheetWalkthroughData.value)
                    ? (_openBlock(), _createBlock(MGButton, {
                        key: 0,
                        text: "Open Walkthrough Drawer",
                        onClick: openWalkthroughDrawer
                    }))
                    : _createCommentVNode("", true),
                (storyWalkthroughData.value)
                    ? (_openBlock(), _createBlock(MGButton, {
                        key: 1,
                        text: "Open Story Page",
                        onClick: openStoryPage,
                        class: "ml-2"
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_4, [
                    _cache[66] || (_cache[66] = _createElementVNode("h3", { class: "mb-0" }, "Loader", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[3] || (_cache[3] = ($event) => (toggleSection('loader'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.loader ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_v_checkbox, {
                        modelValue: loaderCustomer.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((loaderCustomer).value = $event)),
                        label: "Hide Loader",
                        class: "mb-4"
                    }, null, 8, ["modelValue"]),
                    _createVNode(CustomerLoadWait, { customer: loaderCustomer.value }, null, 8, ["customer"])
                ], 512), [
                    [_vShow, sections.value.loader]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_5, [
                    _cache[67] || (_cache[67] = _createElementVNode("h3", { class: "mb-0" }, "Tags", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[5] || (_cache[5] = ($event) => (toggleSection('tags'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.tags ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(TagInput, {
                        selectableTags: selectableTags.value,
                        modelValue: modelValue.value,
                        maxTags: 5,
                        maxTagLength: 10,
                        onChange: _cache[6] || (_cache[6] = (tags) => console.log('Tags changed:', tags)),
                        onAddedNew: _cache[7] || (_cache[7] = (tag) => console.log('New tag added:', tag))
                    }, null, 8, ["selectableTags", "modelValue"])
                ], 512), [
                    [_vShow, sections.value.tags]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_6, [
                    _cache[68] || (_cache[68] = _createElementVNode("h3", { class: "mb-0" }, "Numeric", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[8] || (_cache[8] = ($event) => (toggleSection('numeric'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.numeric ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_v_text_field, {
                        type: "text",
                        label: "Amount",
                        modelValue: amount.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((amount).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createTextVNode(" Float: " + _toDisplayString(amount.value) + " ", 1),
                    _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" Float * 100: " + _toDisplayString(amount.value * 100), 1),
                    _cache[70] || (_cache[70] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" Rounded Float * 100: " + _toDisplayString(Math.round(amount.value * 100)), 1),
                    _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" Pence: " + _toDisplayString(Math.round(amount.value * 100)), 1),
                    _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1))
                ], 512), [
                    [_vShow, sections.value.numeric]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_7, [
                    _cache[73] || (_cache[73] = _createElementVNode("h3", { class: "mb-0" }, "Postcode", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[10] || (_cache[10] = ($event) => (toggleSection('postcode'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.postcode ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(AddressLookup, {
                        theme: "light",
                        modelValue: address.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((address).value = $event))
                    }, null, 8, ["modelValue"])
                ], 512), [
                    [_vShow, sections.value.postcode]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_8, [
                    _cache[74] || (_cache[74] = _createElementVNode("h3", { class: "mb-0" }, "Address Drawer", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[12] || (_cache[12] = ($event) => (toggleSection('addressDrawer'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.addressDrawer ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(MGButton, {
                        text: "Open Address Drawer",
                        onClick: _cache[13] || (_cache[13] = ($event) => (showAddressDrawer.value = true))
                    }),
                    _createVNode(AddressDrawer, {
                        modelValue: showAddressDrawer.value,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((showAddressDrawer).value = $event)),
                        onSaved: _cache[15] || (_cache[15] = (addr) => console.log('Address saved:', addr))
                    }, null, 8, ["modelValue"])
                ], 512), [
                    [_vShow, sections.value.addressDrawer]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_9, [
                    _cache[75] || (_cache[75] = _createElementVNode("h3", { class: "mb-0" }, "Buttons", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[16] || (_cache[16] = ($event) => (toggleSection('buttons'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.buttons ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(BarArrowButton, {
                        icon: require('../assets/coins.png'),
                        title: "Bar Arrow Button",
                        href: "#",
                        large: true
                    }, null, 8, ["icon"]),
                    _createVNode(BarArrowButton, {
                        title: "Bar Arrow Button",
                        href: "#",
                        large: true
                    }),
                    _createVNode(MGButton, { text: "Hello" }),
                    _createVNode(MGButton, { text: "Some Longer Text" }),
                    _createVNode(MGButton, {
                        alt: true,
                        text: "Alt"
                    }),
                    _createVNode(MGButton, {
                        arrow: true,
                        text: "Arrow"
                    }),
                    _createVNode(MGButton, {
                        arrow: true,
                        text: "Long Text With Arrow"
                    }),
                    _createVNode(MGButton, {
                        icon: require('../assets/coins.png'),
                        arrow: true,
                        text: "Icon Arrow"
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        outline: true,
                        icon: require('../assets/coins.png'),
                        arrow: true,
                        text: "O I Arrow"
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        outline: true,
                        icon: require('../assets/coins.png'),
                        arrow: true,
                        text: "O I D",
                        disabled: true
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        alt: true,
                        arrow: true,
                        text: "Alt arrow"
                    }),
                    _createVNode(MGButton, {
                        icon: require('../assets/coins.png'),
                        text: "Icon"
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        icon: require('../assets/coins.png'),
                        text: "Icon disabled",
                        disabled: true
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        alt: true,
                        icon: require('../assets/coins.png'),
                        text: "Alt icon"
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        alt: true,
                        icon: require('../assets/coins.png'),
                        arrow: true,
                        text: "Alt icon arrow"
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        small: true,
                        text: "Small"
                    }),
                    _createVNode(MGButton, {
                        small: true,
                        outline: true,
                        text: "Small"
                    }),
                    _createVNode(MGButton, {
                        small: true,
                        alt: true,
                        text: "Small A"
                    }),
                    _createVNode(MGButton, {
                        small: true,
                        alt: true,
                        arrow: true,
                        text: "Small A A"
                    }),
                    _createVNode(MGButton, {
                        small: true,
                        icon: require('../assets/coins.png'),
                        alt: true,
                        arrow: true,
                        text: "Small I A A"
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        small: true,
                        icon: require('../assets/coins.png'),
                        alt: true,
                        arrow: true,
                        text: "Small I A A D",
                        disabled: true
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        text: "Down with icon",
                        arrow: false,
                        open: true,
                        icon: require('../assets/coins.png')
                    }, null, 8, ["icon"]),
                    _createVNode(MGButton, {
                        text: "Down no icon",
                        arrow: false,
                        open: true
                    }),
                    _createVNode(MGButton, {
                        text: "Left Aligned",
                        outline: true,
                        arrow: true,
                        noCaps: true,
                        leftAlign: true,
                        small: false
                    }),
                    _createVNode(MGButton, {
                        text: "Really Long Left Aligned",
                        outline: true,
                        arrow: true,
                        noCaps: true,
                        leftAlign: true,
                        small: false
                    })
                ], 512), [
                    [_vShow, sections.value.buttons]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_10, [
                    _cache[76] || (_cache[76] = _createElementVNode("h3", { class: "mb-0" }, "Swipe Actions", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[17] || (_cache[17] = ($event) => (toggleSection('swipeActions'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.swipeActions ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                    _createVNode(SwipeActionsContainer, {
                        items: mockSwipeItems.value,
                        actions: [
                            {
                                icon: 'mdi-delete',
                                type: 'delete',
                                backgroundColor: 'var(--background-color-alt)'
                            },
                            {
                                icon: 'mdi-pencil',
                                type: 'edit',
                                backgroundColor: 'var(--background-color-alt)'
                            }
                        ],
                        preview: false,
                        onContentClick: handleSwipeItemClick,
                        onActionClick: handleSwipeAction
                    }, {
                        default: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_v_icon, {
                                        class: "docIcon",
                                        icon: item.icon
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1),
                                        _createElementVNode("div", _hoisted_16, _toDisplayString(item.subtitle), 1)
                                    ]),
                                    _createVNode(_component_v_icon, {
                                        size: "small",
                                        color: "grey"
                                    }, {
                                        default: _withCtx(() => _cache[77] || (_cache[77] = [
                                            _createTextVNode("mdi-chevron-right")
                                        ])),
                                        _: 1
                                    })
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["items"])
                ], 512), [
                    [_vShow, sections.value.swipeActions]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_17, [
                    _cache[78] || (_cache[78] = _createElementVNode("h3", { class: "mb-0" }, "MGDialog", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[18] || (_cache[18] = ($event) => (toggleSection('mgDialog'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.mgDialog ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(MGButton, {
                        text: "Simple Dialog",
                        onClick: _cache[19] || (_cache[19] = ($event) => (showSimpleDialog.value = true)),
                        class: "mb-2"
                    }),
                    _createVNode(MGButton, {
                        text: "Form Dialog",
                        onClick: _cache[20] || (_cache[20] = ($event) => (showFormDialog.value = true)),
                        class: "mb-2"
                    }),
                    _createVNode(MGButton, {
                        text: "Multi-Page Dialog",
                        onClick: _cache[21] || (_cache[21] = ($event) => (showMultiPageDialog.value = true)),
                        class: "mb-2"
                    }),
                    _createVNode(MGDialog, {
                        modelValue: showSimpleDialog.value,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((showSimpleDialog).value = $event)),
                        title: "Simple Confirmation"
                    }, {
                        content: _withCtx(() => _cache[79] || (_cache[79] = [
                            _createElementVNode("p", null, "This is a simple confirmation dialog with just text content.", -1)
                        ])),
                        actions: _withCtx(() => [
                            _createVNode(MGButton, {
                                fullWidth: true,
                                text: "Confirm",
                                onClick: _cache[22] || (_cache[22] = ($event) => (showSimpleDialog.value = false))
                            }),
                            _createVNode(MGButton, {
                                stacked: true,
                                fullWidth: true,
                                outline: true,
                                text: "Cancel",
                                onClick: _cache[23] || (_cache[23] = ($event) => (showSimpleDialog.value = false))
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(MGDialog, {
                        modelValue: showFormDialog.value,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((showFormDialog).value = $event)),
                        title: "Form Example",
                        "max-width": "500px"
                    }, {
                        content: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                                modelValue: formName.value,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((formName).value = $event)),
                                label: "Name",
                                class: "mb-3",
                                variant: "solo",
                                flat: true,
                                clearable: "",
                                "single-line": "",
                                rounded: "",
                                outlined: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                                modelValue: formEmail.value,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((formEmail).value = $event)),
                                label: "Email",
                                type: "email",
                                variant: "solo",
                                flat: true,
                                clearable: "",
                                "single-line": "",
                                rounded: "",
                                outlined: ""
                            }, null, 8, ["modelValue"])
                        ]),
                        actions: _withCtx(() => [
                            _createVNode(MGButton, {
                                fullWidth: true,
                                text: "Save",
                                onClick: saveForm,
                                disabled: !formName.value || !formEmail.value
                            }, null, 8, ["disabled"]),
                            _createVNode(MGButton, {
                                stacked: true,
                                fullWidth: true,
                                outline: true,
                                text: "Cancel",
                                onClick: _cache[27] || (_cache[27] = ($event) => (showFormDialog.value = false))
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(MGDialog, {
                        modelValue: showMultiPageDialog.value,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((showMultiPageDialog).value = $event)),
                        title: "Multi-Page Example",
                        "max-width": "500px"
                    }, {
                        content: _withCtx(() => [
                            (currentPage.value === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _cache[80] || (_cache[80] = _createElementVNode("p", { class: "mb-4" }, "This is page 1 of a multi-page dialog.", -1)),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: page1Data.value,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((page1Data).value = $event)),
                                        label: "Page 1 Data",
                                        variant: "solo",
                                        flat: true,
                                        clearable: "",
                                        "single-line": "",
                                        rounded: "",
                                        outlined: "",
                                        prefix: "£"
                                    }, null, 8, ["modelValue"])
                                ]))
                                : _createCommentVNode("", true),
                            (currentPage.value === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _cache[81] || (_cache[81] = _createElementVNode("p", { class: "mb-4" }, "This is page 2 of a multi-page dialog.", -1)),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: page2Data.value,
                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((page2Data).value = $event)),
                                        label: "Page 2 Data",
                                        variant: "solo",
                                        flat: true,
                                        clearable: "",
                                        "single-line": "",
                                        rounded: "",
                                        outlined: "",
                                        prefix: "£"
                                    }, null, 8, ["modelValue"])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        actions: _withCtx(() => [
                            (currentPage.value === 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(MGButton, {
                                        fullWidth: true,
                                        text: "Next",
                                        onClick: _cache[31] || (_cache[31] = ($event) => (currentPage.value = 2)),
                                        disabled: !page1Data.value
                                    }, null, 8, ["disabled"]),
                                    _createVNode(MGButton, {
                                        stacked: true,
                                        fullWidth: true,
                                        outline: true,
                                        text: "Cancel",
                                        onClick: closeMultiPageDialog
                                    })
                                ], 64))
                                : _createCommentVNode("", true),
                            (currentPage.value === 2)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(MGButton, {
                                        fullWidth: true,
                                        text: "Complete",
                                        onClick: completeMultiPage,
                                        disabled: !page2Data.value
                                    }, null, 8, ["disabled"]),
                                    _createVNode(MGButton, {
                                        stacked: true,
                                        fullWidth: true,
                                        outline: true,
                                        text: "Back",
                                        onClick: _cache[32] || (_cache[32] = ($event) => (currentPage.value = 1))
                                    })
                                ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ], 512), [
                    [_vShow, sections.value.mgDialog]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_20, [
                    _cache[82] || (_cache[82] = _createElementVNode("h3", { class: "mb-0" }, "Savings Card", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[34] || (_cache[34] = ($event) => (toggleSection('savingsCard'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.savingsCard ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_21, [
                        _createVNode(SavingsCard, {
                            items: mockSavingsItems.value,
                            formatter: { format: v => '£' + v.toLocaleString() }
                        }, null, 8, ["items", "formatter"])
                    ])
                ], 512), [
                    [_vShow, sections.value.savingsCard]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_22, [
                    _cache[83] || (_cache[83] = _createElementVNode("h3", { class: "mb-0" }, "Month Selector", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[35] || (_cache[35] = ($event) => (toggleSection('monthSelector'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.monthSelector ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_23, [
                        _cache[84] || (_cache[84] = _createElementVNode("strong", null, "Selected Month:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedMonth.value), 1)
                    ]),
                    _createVNode(MonthSelector, {
                        modelValue: selectedMonth.value,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((selectedMonth).value = $event)),
                        slots: mockMonthSlots.value
                    }, null, 8, ["modelValue", "slots"])
                ], 512), [
                    [_vShow, sections.value.monthSelector]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_24, [
                    _cache[85] || (_cache[85] = _createElementVNode("h3", { class: "mb-0" }, "Pagination Dots", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[37] || (_cache[37] = ($event) => (toggleSection('paginationDots'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.paginationDots ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_25, [
                        _cache[86] || (_cache[86] = _createElementVNode("strong", null, "Current Index:", -1)),
                        _createTextVNode(" " + _toDisplayString(paginationCurrentIndex.value) + " / " + _toDisplayString(paginationTotalItems.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _createVNode(MGButton, {
                            small: true,
                            text: "Previous",
                            onClick: prevItem,
                            disabled: paginationCurrentIndex.value === 0
                        }, null, 8, ["disabled"]),
                        _createVNode(MGButton, {
                            small: true,
                            text: "Next",
                            onClick: nextItem,
                            disabled: paginationCurrentIndex.value === paginationTotalItems.value - 1
                        }, null, 8, ["disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                            _cache[87] || (_cache[87] = _createElementVNode("h4", null, "5 Items (default maxDots)", -1)),
                            _createVNode(PaginationDots, {
                                "total-items": 5,
                                "current-index": Math.min(paginationCurrentIndex.value, 4)
                            }, null, 8, ["current-index"])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                            _cache[88] || (_cache[88] = _createElementVNode("h4", null, "10 Items (shows sliding window)", -1)),
                            _createVNode(PaginationDots, {
                                "total-items": 10,
                                "current-index": Math.min(paginationCurrentIndex.value, 9)
                            }, null, 8, ["current-index"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _cache[89] || (_cache[89] = _createElementVNode("h4", null, "Custom maxDots (3)", -1)),
                            _createVNode(PaginationDots, {
                                "total-items": paginationTotalItems.value,
                                "current-index": paginationCurrentIndex.value,
                                "max-dots": 3
                            }, null, 8, ["total-items", "current-index"])
                        ])
                    ])
                ], 512), [
                    [_vShow, sections.value.paginationDots]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_31, [
                    _cache[90] || (_cache[90] = _createElementVNode("h3", { class: "mb-0" }, "Smooth Scroll Container, Categories", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[38] || (_cache[38] = ($event) => (toggleSection('smoothScroll'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.smoothScroll ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SmoothScrollContainer, null, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockCategories.value, (category, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass('smoothScrollContainerItem'),
                                    key: category.title
                                }, [
                                    (_openBlock(), _createBlock(CategoryButton, {
                                        key: index,
                                        title: category.title,
                                        image: category.image,
                                        class: "mr-4"
                                    }, null, 8, ["title", "image"]))
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, sections.value.smoothScroll]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_32, [
                    _cache[91] || (_cache[91] = _createElementVNode("h3", { class: "mb-0" }, "Nav Panel", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[39] || (_cache[39] = ($event) => (toggleSection('navPanel'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.navPanel ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(MGNavPanel, {
                        title: "Boosted",
                        subtitle: "Save whilst they last",
                        icon: require('@/assets/lightning-bolt.png'),
                        onClick: onNavPanelClick
                    }, null, 8, ["icon"])
                ], 512), [
                    [_vShow, sections.value.navPanel]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_33, [
                    _cache[92] || (_cache[92] = _createElementVNode("h3", { class: "mb-0" }, "Buy With Confidence Shout Panel", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[40] || (_cache[40] = ($event) => (toggleSection('buyWithConfidence'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.buyWithConfidence ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(BuyWithConfidenceShoutPanel)
                ], 512), [
                    [_vShow, sections.value.buyWithConfidence]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_34, [
                    _cache[93] || (_cache[93] = _createElementVNode("h3", { class: "mb-0" }, "Re-Link Accounts For Vouchers Shout Panel", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[41] || (_cache[41] = ($event) => (toggleSection('reLinkAccountsForVouchers'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.reLinkAccountsForVouchers ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(ReLinkAccountsForVouchersShoutPanel)
                ], 512), [
                    [_vShow, sections.value.reLinkAccountsForVouchers]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_35, [
                    _cache[94] || (_cache[94] = _createElementVNode("h3", { class: "mb-0" }, "Voucher Recommended For You", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[42] || (_cache[42] = ($event) => (toggleSection('VoucherRecommendedForYou'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.VoucherRecommendedForYou ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _createVNode(SwipeCarousel, {
                    showArrows: false,
                    showButtons: false,
                    paginationDots: true,
                    height: '370px'
                }, {
                    default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_v_carousel_item, null, {
                            default: _withCtx(() => [
                                _createVNode(VoucherRecommendedForYou, {
                                    imageUrl: require('../assets/bg/Currys.png'),
                                    category: "Technology",
                                    isFavorited: true,
                                    spendLabel: "Where you spent the most",
                                    merchantLogoUrl: "https://s3.eu-west-2.amazonaws.com/content.sysodev.link/257ad329-Porthole.png",
                                    merchantName: "Currys",
                                    spendInfo: "June spend: £1,200",
                                    savingsAmount: 10.50,
                                    savingsPercentage: 5.5,
                                    formatter: { format: v => '£' + v.toLocaleString() }
                                }, null, 8, ["imageUrl", "formatter"])
                            ]),
                            _: 1
                        }, 512), [
                            [_vShow, sections.value.VoucherRecommendedForYou]
                        ]),
                        _withDirectives(_createVNode(_component_v_carousel_item, null, {
                            default: _withCtx(() => [
                                _createVNode(VoucherRecommendedForYou, {
                                    imageUrl: require('../assets/bg/Currys.png'),
                                    category: "Technology",
                                    isFavorited: true,
                                    spendLabel: "Where you spent the most",
                                    merchantLogoUrl: "https://s3.eu-west-2.amazonaws.com/content.sysodev.link/257ad329-Porthole.png",
                                    merchantName: "Currys",
                                    spendInfo: "June spend: £1,200",
                                    savingsAmount: 10.50,
                                    savingsPercentage: 5.5,
                                    formatter: { format: v => '£' + v.toLocaleString() }
                                }, null, 8, ["imageUrl", "formatter"])
                            ]),
                            _: 1
                        }, 512), [
                            [_vShow, sections.value.VoucherRecommendedForYou]
                        ])
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_36, [
                    _cache[95] || (_cache[95] = _createElementVNode("h3", { class: "mb-0" }, "Voucher Recommended For You Small", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[43] || (_cache[43] = ($event) => (toggleSection('VoucherRecommendedForYouSmall'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.VoucherRecommendedForYouSmall ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SmoothScrollContainer, null, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockCategories.value, (category, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass('smoothScrollContainerItem'),
                                    key: category.title
                                }, [
                                    (_openBlock(), _createBlock(VoucherRecommendedForYou, {
                                        key: index,
                                        "image-url": "https://s3.eu-west-2.amazonaws.com/content.sysodev.link/358f1c73-Technology.png",
                                        isFavorited: true,
                                        "merchant-logo-url": "https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/cote-brasserie.jpg",
                                        "merchant-name": "Currys",
                                        "spend-info": "June spend: £1,200",
                                        "savings-amount": 10.50,
                                        "savings-percentage": 5.5,
                                        small: true,
                                        formatter: { format: v => '£' + v.toLocaleString() }
                                    }, null, 8, ["formatter"]))
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, sections.value.VoucherRecommendedForYouSmall]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_37, [
                    _cache[96] || (_cache[96] = _createElementVNode("h3", { class: "mb-0" }, "Saving Opportunity Card", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[44] || (_cache[44] = ($event) => (toggleSection('savingOpportunityCard'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.savingOpportunityCard ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SmoothScrollContainer, null, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockSavingOpportunities.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(['smoothScrollContainerItem', "mr-2"]),
                                    key: index
                                }, [
                                    (_openBlock(), _createBlock(VoucherSavingSuggestions, {
                                        key: index,
                                        labelValue: item.totalSpendAmount,
                                        label: item.totalSpendLabel,
                                        logoUrl: item.logoUrl,
                                        logoAltText: item.logoAltText,
                                        savingAmount: item.savingAmount,
                                        savingPercentage: item.savingPercentage,
                                        logoBackgroundColor: item.logoBackgroundColor
                                    }, null, 8, ["labelValue", "label", "logoUrl", "logoAltText", "savingAmount", "savingPercentage", "logoBackgroundColor"]))
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, sections.value.savingOpportunityCard]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_38, [
                    _cache[97] || (_cache[97] = _createElementVNode("h3", { class: "mb-0" }, "Voucher Merchant Card", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[45] || (_cache[45] = ($event) => (toggleSection('merchantCard'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.merchantCard ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SmoothScrollContainer, null, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockMerchantCards.value, (card, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(['smoothScrollContainerItem', "mr-2"]),
                                    key: index
                                }, [
                                    _createVNode(VoucherMerchantCard, {
                                        logoUrl: card.logoUrl,
                                        merchantName: card.merchantName,
                                        savingPercentage: card.savingPercentage,
                                        isFavorited: card.isFavorited
                                    }, null, 8, ["logoUrl", "merchantName", "savingPercentage", "isFavorited"])
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, sections.value.merchantCard]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_39, [
                    _cache[98] || (_cache[98] = _createElementVNode("h3", { class: "mb-0" }, "Section Header", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[46] || (_cache[46] = ($event) => (toggleSection('sectionHeader'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.sectionHeader ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SectionHeader, {
                        title: "Categories",
                        subtitle: "Discover how you can save",
                        actionLabel: "View all",
                        onAction: onSectionHeaderAction
                    })
                ], 512), [
                    [_vShow, sections.value.sectionHeader]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_40, [
                    _cache[99] || (_cache[99] = _createElementVNode("h3", { class: "mb-0" }, "Voucher Basket", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[47] || (_cache[47] = ($event) => (toggleSection('voucherBasket'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.voucherBasket ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                            _cache[100] || (_cache[100] = _createElementVNode("h4", null, "Default Configuration", -1)),
                            _createVNode(VoucherBasket, {
                                onClick: _cache[48] || (_cache[48] = ($event) => (handleVoucherBasketClick('default')))
                            })
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                            _cache[101] || (_cache[101] = _createElementVNode("h4", null, "Multiple Vouchers", -1)),
                            _createVNode(VoucherBasket, {
                                voucherCount: 3,
                                totalAmount: 250.50,
                                onClick: _cache[49] || (_cache[49] = ($event) => (handleVoucherBasketClick('multiple')))
                            })
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                            _cache[102] || (_cache[102] = _createElementVNode("h4", null, "Custom Text", -1)),
                            _createVNode(VoucherBasket, {
                                voucherCount: 2,
                                totalAmount: 75.99,
                                basketText: "Complete purchase",
                                onClick: _cache[50] || (_cache[50] = ($event) => (handleVoucherBasketClick('custom')))
                            })
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                            _cache[103] || (_cache[103] = _createElementVNode("h4", null, "Large Amount", -1)),
                            _createVNode(VoucherBasket, {
                                voucherCount: 5,
                                totalAmount: 1234.56,
                                basketText: "Proceed to checkout",
                                onClick: _cache[51] || (_cache[51] = ($event) => (handleVoucherBasketClick('large')))
                            })
                        ])
                    ])
                ], 512), [
                    [_vShow, sections.value.voucherBasket]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_46, [
                    _cache[104] || (_cache[104] = _createElementVNode("h3", { class: "mb-0" }, "Card Account Group", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[52] || (_cache[52] = ($event) => (toggleSection('cardAccountGroup'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.cardAccountGroup ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockCardAccountGroups.value, (card, index) => {
                            return (_openBlock(), _createBlock(CardAccountGroup, {
                                key: index,
                                "card-title": card.cardTitle,
                                amount: card.amount,
                                "illustration-url": card.illustrationUrl,
                                "account-avatars": card.accountAvatars,
                                formatter: { format: v => '£' + v.toLocaleString() },
                                class: "mr-4"
                            }, null, 8, ["card-title", "amount", "illustration-url", "account-avatars", "formatter"]));
                        }), 128))
                    ])
                ], 512), [
                    [_vShow, sections.value.cardAccountGroup]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_48, [
                    _cache[105] || (_cache[105] = _createElementVNode("h3", { class: "mb-0" }, "Account List Item", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[53] || (_cache[53] = ($event) => (toggleSection('accountListItem'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.accountListItem ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_49, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockAccountListItems.value, (account, index) => {
                            return (_openBlock(), _createBlock(AccountListItem, {
                                key: index,
                                "provider-name": account.bankName,
                                line1: account.accountType,
                                line2: account.accountNumber,
                                value: '£' + account.balance.toLocaleString(),
                                "avatar-url": account.avatarUrl,
                                "badge-url": account.badgeUrl,
                                onClick: ($event) => (handleAccountListItemClick(account)),
                                class: "mb-3"
                            }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "badge-url", "onClick"]));
                        }), 128))
                    ])
                ], 512), [
                    [_vShow, sections.value.accountListItem]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_50, [
                    _cache[106] || (_cache[106] = _createElementVNode("h3", { class: "mb-0" }, "Account Type Lozenge", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[54] || (_cache[54] = ($event) => (toggleSection('accountTypeLozenge'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.accountTypeLozenge ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockAccountTypeLozenges.value, (lozenge, index) => {
                            return (_openBlock(), _createBlock(AccountTypeLozenge, {
                                key: index,
                                "account-type": lozenge.accountType,
                                "account-count": lozenge.accountCount,
                                "icon-url": lozenge.iconUrl,
                                "is-add-button": lozenge.isAddButton,
                                onClick: handleAccountTypeLozengeClick
                            }, null, 8, ["account-type", "account-count", "icon-url", "is-add-button"]));
                        }), 128))
                    ])
                ], 512), [
                    [_vShow, sections.value.accountTypeLozenge]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_52, [
                    _cache[107] || (_cache[107] = _createElementVNode("h3", { class: "mb-0" }, "Saved to Spend Balance", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[55] || (_cache[55] = ($event) => (toggleSection('savedToSpendBalance'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.savedToSpendBalance ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SavedToSpendBalance, {
                        balance: 0.25,
                        stat1Value: 640.35,
                        stat2Value: 1230.20,
                        stat3Value: "7%",
                        formatter: { format: v => '£' + v.toFixed(2) },
                        onShopClick: handleShopClick
                    }, null, 8, ["formatter"])
                ], 512), [
                    [_vShow, sections.value.savedToSpendBalance]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_53, [
                    _cache[108] || (_cache[108] = _createElementVNode("h3", { class: "mb-0" }, "Recent Discount Transactions", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[56] || (_cache[56] = ($event) => (toggleSection('recentDiscountTransactions'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.recentDiscountTransactions ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(DiscountTransactionsSection, {
                        days: mockTransactionDays.value,
                        maxDays: 3,
                        formatter: { format: v => '£' + v.toFixed(2) },
                        onViewMore: handleViewMoreTransactions
                    }, null, 8, ["days", "formatter"])
                ], 512), [
                    [_vShow, sections.value.recentDiscountTransactions]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_54, [
                    _cache[109] || (_cache[109] = _createElementVNode("h3", { class: "mb-0" }, "Progress Dial", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[57] || (_cache[57] = ($event) => (toggleSection('progressDial'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.progressDial ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(ProgressDial, {
                        fromDate: "2025-06-01",
                        toDate: "2026-06-01",
                        title: "Days until renewal",
                        footerLabel: "Renewal"
                    })
                ], 512), [
                    [_vShow, sections.value.progressDial]
                ]),
                _createVNode(_component_v_divider, { class: "my-6" }),
                _createElementVNode("div", _hoisted_55, [
                    _cache[110] || (_cache[110] = _createElementVNode("h3", { class: "mb-0" }, "Progress Dial V2", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[58] || (_cache[58] = ($event) => (toggleSection('progressDialV2'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.progressDialV2 ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(ProgressDialV2, {
                        fromDate: "2025-04-01",
                        toDate: "2026-04-01",
                        title: "Renewal",
                        image: require('@/assets/InsuranceTypesContents.png'),
                        infoMessage: "Policy renews soon – get ahead and look for new offers and deals in good time."
                    }, null, 8, ["image"]),
                    _cache[111] || (_cache[111] = _createElementVNode("h3", { class: "mb-0" }, "MGToggle", -1)),
                    _createVNode(_component_v_btn, {
                        icon: "",
                        size: "xx-small",
                        onClick: _cache[59] || (_cache[59] = ($event) => (toggleSection('mgToggle'))),
                        class: "ml-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(sections.value.mgToggle ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, sections.value.progressDialV2]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                            _cache[112] || (_cache[112] = _createElementVNode("span", null, "Large (on):", -1)),
                            _createVNode(MGToggle, {
                                modelValue: toggleLargeOn.value,
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event) => ((toggleLargeOn).value = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                            _cache[113] || (_cache[113] = _createElementVNode("span", null, "Large (off):", -1)),
                            _createVNode(MGToggle, {
                                modelValue: toggleLargeOff.value,
                                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event) => ((toggleLargeOff).value = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                            _cache[114] || (_cache[114] = _createElementVNode("span", null, "Small (on):", -1)),
                            _createVNode(MGToggle, {
                                modelValue: toggleSmallOn.value,
                                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event) => ((toggleSmallOn).value = $event)),
                                size: "small"
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                            _cache[115] || (_cache[115] = _createElementVNode("span", null, "Small (off):", -1)),
                            _createVNode(MGToggle, {
                                modelValue: toggleSmallOff.value,
                                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event) => ((toggleSmallOff).value = $event)),
                                size: "small"
                            }, null, 8, ["modelValue"])
                        ])
                    ])
                ], 512), [
                    [_vShow, sections.value.mgToggle]
                ]),
                _createVNode(WalkthroughDrawerPanel, {
                    ref_key: "walkthroughDrawer",
                    ref: walkthroughDrawer,
                    walkthroughData: sheetWalkthroughData.value,
                    variant: "sheet",
                    onDrawerOpened: handleWalkthroughOpened,
                    onDrawerClosed: handleWalkthroughClosed
                }, null, 8, ["walkthroughData"])
            ], 64));
        };
    }
});
